import { type FunctionComponent } from "react";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { useResponsive } from "shared/hooks";
import { theme } from "shared/lib/styles";

import { pathname as livePathname } from "scmp-app/pages/live";
import type { latestContentsQuery$data } from "scmp-app/queries/__generated__/latestContentsQuery.graphql";

import { ItemTrendingNavBarLatestSwiper } from "./item";
import {
  CenteredContainer,
  MoreLatestNewsLink,
  StyledIconArrow,
  StyledSwiper,
  StyledSwiperSlide,
} from "./styles";

type Props = {
  edition: string;
  latestItems: latestContentsQuery$data["contents"]["edges"];
};

export const TrendingNavBarLatestSwiper: FunctionComponent<Props> = ({ edition, latestItems }) => {
  const isTabletUp = useResponsive(theme.breakpoints.up("tablet"), false);

  if (latestItems.length === 0) return null;

  return (
    <CenteredContainer>
      {latestItems.length > 0 && (
        <StyledSwiper
          cssMode={false}
          pagination={false}
          slidesOffsetAfter={isTabletUp ? 0 : 20}
          slidesPerView="auto"
        >
          {latestItems.map(item => (
            <StyledSwiperSlide key={item.node.entityId}>
              <ItemTrendingNavBarLatestSwiper edition={edition} reference={item.node} />
            </StyledSwiperSlide>
          ))}
          <StyledSwiperSlide>
            <BaseLinkContextProvider
              customQueryParameters={{
                module: `oneline_menu_trending_${edition}`,
                pgtype: "homepage",
              }}
            >
              <MoreLatestNewsLink as={livePathname} pathname={livePathname}>
                More
                <br />
                Latest
                <br />
                News
                <br />
                <StyledIconArrow />
              </MoreLatestNewsLink>
            </BaseLinkContextProvider>
          </StyledSwiperSlide>
        </StyledSwiper>
      )}
    </CenteredContainer>
  );
};

TrendingNavBarLatestSwiper.displayName = "TrendingNavBarLatestSwiper";
